import { PayPalScriptProvider, PayPalMessages } from '@paypal/react-paypal-js'

export type PaypalPayLaterProps = {
  totalPrice: number
  placement?: 'home' | 'category' | 'product' | 'cart' | 'payment'
}

export function PaypalPayLater(props: PaypalPayLaterProps) {
  const { totalPrice, placement } = props

  return (
    <div className='my-[10px]'>
      <PayPalScriptProvider
        options={{
          clientId: process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID!,
          components: 'buttons,messages',
          enableFunding: 'paylater',
        }}
      >
        <PayPalMessages
          style={{ layout: 'text' }}
          forceReRender={[{ layout: 'text' }]}
          amount={totalPrice}
          placement={placement}
        />
      </PayPalScriptProvider>
    </div>
  )
}
